import React, { createContext, useContext } from "react";
import apiService, { getBaseURL } from "../services/api";
import useApiData from "../hooks/useApiData";

/**
 * Context for managing footer content
 * Provides footer data including social networks, copyright information, and logo
 */
const FooterContext = createContext();

export const useFooter = () => {
  const context = useContext(FooterContext);

  if (!context) {
    throw new Error("useFooter must be used within a FooterProvider");
  }

  return context;
};

export const FooterProvider = ({ children }) => {
  const {
    data: footerData,
    loading,
    error,
    refetch,
  } = useApiData(() => apiService.getFooter(), [], {
    unwrapStrapi: true,
    resourceName: "footer",
  });

  // Helper function to get footer logo URL
  const getFooterLogoUrl = () => {
    if (footerData?.logo?.url) {
      const logoUrl = footerData.logo.url;
      // If the URL is relative, use Strapi's base URL
      if (logoUrl.startsWith("/")) {
        const strapiBaseUrl = getBaseURL();
        return strapiBaseUrl + logoUrl;
      }
      return logoUrl;
    }
    return null;
  };

  const value = {
    footerData,
    loading,
    error,
    getFooterLogoUrl,
    refetch,
  };

  return <FooterContext.Provider value={value}>{children}</FooterContext.Provider>;
};
